import type { TrendBucket } from '@/pages/analytics/types';

const parseChartDate = (value: unknown): Date | null => {
  if (typeof value === 'number') {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmed);

  if (dateOnly) {
    const [, year, month, day] = dateOnly;
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  const date = new Date(trimmed);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatChartAxisDate = (value: unknown, trendBucket: TrendBucket = 'day'): string => {
  const date = parseChartDate(value);
  if (!date) return String(value ?? '');

  if (trendBucket === 'month') {
    return new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric' }).format(date);
  }

  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(date);
};

export const formatChartTooltipDate = (
  value: unknown,
  trendBucket: TrendBucket = 'day',
): string => {
  const date = parseChartDate(value);
  if (!date) return String(value ?? '');

  switch (trendBucket) {
    case 'week':
      return `Week of ${new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(date)}`;
    case 'month':
      return `Month of ${new Intl.DateTimeFormat('en-US', {
        month: 'long',
        year: 'numeric',
      }).format(date)}`;
    default:
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      }).format(date);
  }
};
